var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.435,
    height: 26.015,
    viewBox: "0 0 37.435 26.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_31890",
    x: 0,
    y: 0,
    width: 37.435,
    height: 26.015,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No-Flag",
    transform: "translate(1.499 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Rectangle_31890)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31890-2",
    "data-name": "Rectangle 31890",
    width: 34.435,
    height: 23.015,
    transform: "translate(1.5 0.5)",
    fill: "#fa2b2d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_40597",
    "data-name": "Path 40597",
    d: "M6.679,0V10.2H26.352V8.778H8.286V0Z",
    transform: "translate(8.084 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40598",
    "data-name": "Path 40598",
    d: "M6.679,5.638v10.2H8.286V7.063H26.352V5.638Z",
    transform: "translate(8.084 7.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40599",
    "data-name": "Path 40599",
    d: "M0,5.638V7.063H10.452v8.776h1.622V5.638Z",
    transform: "translate(0.001 7.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40600",
    "data-name": "Path 40600",
    d: "M10.452,0V8.778H0V10.2H12.074V0Z",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40601",
    "data-name": "Path 40601",
    d: "M12.074,0V10.121H0v2.772H12.074V23.014h2.688V12.893H34.435V10.121H14.762V0Z",
    transform: "translate(0.001 0.001)",
    fill: "#00148d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFlag);
export default __webpack_public_path__ + "static/media/No-Flag.9e08812a27e68e3eacd52c8115274f72.svg";
export { ForwardRef as ReactComponent };